const config = {
};

export default config;
